import React, { useState } from "react"
import { t } from "i18next"
import {notification, Tag,TextInput,Flex} from ".."

const TagInput = ({
  onTagsEntered=()=>{},
  inputWidth = "100%",
  preventDuplicates = true,
  placeholder = "Enter Tags",
  renderTag,
  autoFocus=false,
  onTagRemove=()=>{},
  maxLength=25,
  tagColor="#009F2B",
  tagType="light",
  value,
  disableOnMaxTags=false,
  maxTags=1,
  allowClear=true,
  inputTitle="",
  textInputSize="middle"
}) => {
  const [tags, setTags] = useState(value || [])
  const [inputValue, setInputValue] = useState('')

  const updateTags = newTags => {
    setTags(newTags)
    onTagsEntered?.(newTags)
  }

  const handleClose = removedTag => {
    const newTags = tags.filter(tag => tag !== removedTag)
    updateTags(newTags)
    onTagRemove?.(removedTag)
  }

  const handleInputConfirm = e => {
    e?.preventDefault()
    const trimmedText = e?.target?.value.trim()
    if (trimmedText && preventDuplicates && tags?.includes(trimmedText)) {
      notification.error({ message: t(`${trimmedText} tag already exists!`) })
      setInputValue("")
      return
    }
    else if ( trimmedText && tags?.length >= maxTags) {
      notification.error({ message: t(`Maximum of ${maxTags} ${inputTitle} allowed!`) })
      setInputValue("")
      return
    }
    else if (trimmedText && (!preventDuplicates || !tags?.includes(trimmedText))) {
      updateTags([...tags, trimmedText])
    }
    setInputValue("")
  }

  return (
    <>
      <TextInput
        autoFocus={autoFocus}
        size={textInputSize}
        style={{ width: inputWidth }}
        maxLength={maxLength}
        disabled={disableOnMaxTags && tags?.length>=maxTags}
        value={inputValue}
        onBlur={handleInputConfirm}
        onPressEnter={handleInputConfirm}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={placeholder}
        allowClear={allowClear}
        className={"mbe-12"}
      />
      <Flex wrap gap="2px 8px" style={{width : "100%"}}>
        {tags?.map(tag => (
          <span key={tag} style={{ display: "inline-block" }}>
            {renderTag ? (
              renderTag(tag, () => handleClose(tag))
            ) : (
              <Tag
                closable
                onClose={e => {
                  e.preventDefault()
                  handleClose(tag)
                }}
                className="pi-8 pb-4 pointer mbe-12"
                type={tagType}
                color={tagColor}
                style={{
                  marginInlineEnd: 4,
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                {tag}
              </Tag>
            )}
          </span>
        ))}
      </Flex>
    </>
  )
}

export default TagInput
